import { createApp, h } from 'vue';
import HistoryModel from './HistoryModel.vue';
import { useUserProfileStore } from "@/stores/user-profile";

export default {    
    install: (app) => {
        const userProfileStore = useUserProfileStore();
        app.config.globalProperties.$auditLogs = (id, model) => {
            const div = document.createElement('div');
            const instance = createApp(HistoryModel, { 
                    activityId: id, 
                    activity: model,
                    onClose: () => document.body.removeChild(div)
            });
            instance.mount(div);
            document.body.appendChild(div);
        };

        app.config.globalProperties.$canAuditLogs = () => {
            return userProfileStore?.user?.isAdmin
        }
    }
};